export function classNameBuilder(...classes: (string | false | 0 | null | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}
